// Б.2.c: Нарколаборатория — триггер «В начале каждого второго хода».
//
// В Ф1 чётных ходов матча (turn 2, 4, 6, ...): даёт случайный Мод
// СЛУЧАЙНОМУ союзному юниту своего владельца.
//
// Правила:
//   - Счётчик ходов — общий счётчик хода матча (как в Режиме ожидания).
//   - Случайный Мод — равновероятный из ВСЕХ 8 Модов Синтетикса (общий пул,
//     не из колоды владельца).
//   - Случайный союзный юнит — равновероятный среди ЖИВЫХ юнитов владельца
//     на поле, ВКЛЮЧАЯ саму Нарколабораторию.
//   - Эффективная цена 0: НЕТ урона Герою, НЕТ инкремента modPlaysCount.
//     Достигается тем, что мы вызываем attachMod напрямую с
//     source.isPlayed=false (триггер, не розыгрыш).
//   - Хирург в этом случае НЕ реагирует — это прикрепление из триггера.
//   - Если живых юнитов нет — триггер пропадает.

import { cards as cardsSyn } from '../../../data/cards-syntetics.js';

export const CARD_ID = 'syn_narcolab';

// Вызывается из onTurnStart для каждой Нарколаборатории на поле.
//   attachModFn — передаётся из вызывающего модуля, чтобы избежать циклов.
export function narkolaboratoriyaOnTurnStart(state, idx, narkUnit, attachModFn) {
  if (!narkUnit.isAlive()) return;
  // Только в Ф1 чётных ходов.
  if ((state.currentTurn % 2) !== 0) return;
  const p = state.players[idx];
  // Пул юнитов-кандидатов: живые юниты владельца, в т.ч. сама Нарколаборатория.
  const allies = p.unitsOnField();
  if (allies.length === 0) {
    state.log.add(`🧪 Нарколаборатория [${p.name}]: нет живых союзников — Мод не выдан`);
    return;
  }
  const target = allies[state.rng.int(allies.length)];
  // Пул Модов: все 8 типов из общего пула фракции.
  const modPool = cardsSyn.filter(c => c.type === 'mod');
  if (modPool.length === 0) return;
  const tpl = modPool[state.rng.int(modPool.length)];
  state.log.add(`🧪 Нарколаборатория [${p.name}]: Мод ${tpl.name_ru} → ${target.name_ru}`);
  attachModFn(state, target, { id: tpl.id, name_ru: tpl.name_ru }, {
    cardId: CARD_ID, ownerIdx: idx
  });
  // attachMod без isPlayed — Хирург не реагирует, modPlaysCount не растёт.
}
